import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>
      This associate has PNOV-compliant packages associated with their stow scan action. This indicates that packages were
      found in containers they were not scanned to, creating a virtual-physical mismatch. Using the Apollo audit, asscoiate
      workflow will need to be observed in order to root cause these virtual physical mismatches. Common root causes are:
    </p>
    <p>
      1) Associates removing packages from a bag in order to rearrange bag contents<br/>
      2) Overstuffed bags that will not close cleanly and need to be double binned<br/>
      3) Failure to close bags at the end of the sort resulting in packages falling out of the bags during the pick process
    </p>
    <p><strong>Impact</strong></p>
    <p>PNOV-compliant packages cause extra stops for drivers, decreasing route efficiency, reprocessing, and overall this
      causes customer dissatisfaction due to potential delays in delivery.</p>
    <p><strong>Resolution Steps</strong></p>
    <p>
      1) Answer questions in the Additional Inputs section to complete this action.<br/>
      2) Change Atlas Action message status to "closed".<br/>
      3) Remove any physical barriers within the station such as:
    </p>
    <ul>
      <li>Excessive double bins</li>
      <li>No oversize space</li>
      <li>Loose velcro or broken zippers on bags</li>
      <li>Excessive double bins</li>
      <li>No oversize space</li>
    </ul>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1)
      <span className="wikiinternallink">
            <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/ea55bb6f-0306-470e-9107-1f47fed3d299/sheets/ea55bb6f-0306-470e-9107-1f47fed3d299_dd6516a7-4f15-401c-9e61-9d1e117ccd4d">PNOV Deep Dive</a>
        </span>
      <br/>
      2)
      <span className="wikiinternallink">
            <a
              href="https://amazonprojects.corp.amazon.com/sites/AMZLACES2/processdocs/_layouts/15/WopiFrame2.aspx?sourcedoc=%7b2AF1E0B9-9C6C-4FC1-BC0D-4ED1C26B6EB1%7d&amp;file=Stow%20Process%20Path%20SOP.pdf&amp;action=default">
                Stow Process Path SOP
            </a>
        </span>
    </p>
    <div className="wikimodel-emptyline"></div>
    <div className="wikimodel-emptyline"></div>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_PNOVC.jsx